import axios, { AxiosResponse } from "axios";
import {
	Component,
	ComponentInstance,
	Environment,
	ProductInstance,
	OperationalConfiguration,
	OperationalConfigurationOverride,
} from "../../models/OperationalConfiguration";

export const getEnvironments = (productId: string) => async (): Promise<AxiosResponse<Environment[]>> => {
	return await axios.get(`/api/v1/${productId}/operationalConfigurations/environments`);
};

export const getProductInstances = (productId: string) => async (): Promise<AxiosResponse<ProductInstance[]>> => {
	return await axios.get(`/api/v1/${productId}/operationalConfigurations/productInstances`);
};

export const getComponents = (productId: string) => async (): Promise<AxiosResponse<Component[]>> => {
	return await axios.get(`/api/v1/${productId}/operationalConfigurations/components`);
};

export const getComponentInstances = (productId: string) => async (): Promise<AxiosResponse<ComponentInstance[]>> => {
	return await axios.get(`/api/v1/${productId}/operationalConfigurations/componentInstances`);
};

export const getOperationalConfigurations =
	(productId: string) => async (): Promise<AxiosResponse<OperationalConfiguration[]>> => {
		return await axios.get(`/api/v1/${productId}/operationalConfigurations`);
	};

export const getOperationalConfiguration =
	(productId: string, operationalConfigurationId: string) =>
	async (): Promise<AxiosResponse<OperationalConfiguration>> => {
		return await axios.get(`/api/v1/${productId}/operationalConfigurations/${operationalConfigurationId}`);
	};

export const deleteOperationalConfiguration =
	(productId: string, operationalConfigurationId: string) => async (): Promise<AxiosResponse> => {
		return await axios.delete(`/api/v1/${productId}/operationalConfigurations/${operationalConfigurationId}`);
	};

export const addOperationalConfiguration =
	(productId: string, operationalConfiguration: OperationalConfiguration) => async (): Promise<AxiosResponse> => {
		return await axios.post(`/api/v1/${productId}/operationalConfigurations`, operationalConfiguration);
	};

export const editOperationalConfiguration =
	(productId: string, operationalConfigurationId: string, operationalConfiguration: OperationalConfiguration) =>
	async (): Promise<AxiosResponse> => {
		return await axios.put(
			`/api/v1/${productId}/operationalConfigurations/${operationalConfigurationId}`,
			operationalConfiguration,
		);
	};

export const deleteOperationalConfigurationOverride =
	(productId: string, operationalConfigurationOverrideId: string) => async (): Promise<AxiosResponse> => {
		return await axios.delete(
			`/api/v1/${productId}/operationalConfigurations/overrides/${operationalConfigurationOverrideId}`,
		);
	};

export const addOperationalConfigurationOverride =
	(productId: string, operationalConfigurationOverride: OperationalConfigurationOverride) =>
	async (): Promise<AxiosResponse> => {
		return await axios.post(
			`/api/v1/${productId}/operationalConfigurations/overrides`,
			operationalConfigurationOverride,
		);
	};

export const editOperationalConfigurationOverride =
	(
		productId: string,
		operationalConfigurationOverrideId: string,
		operationalConfigurationOverride: OperationalConfigurationOverride,
	) =>
	async (): Promise<AxiosResponse> => {
		return await axios.put(
			`/api/v1/${productId}/operationalConfigurations/overrides/${operationalConfigurationOverrideId}`,
			operationalConfigurationOverride,
		);
	};
